import { render } from "./CLabel.vue?vue&type=template&id=377e10e2"
import script from "./CLabel.vue?vue&type=script&lang=js"
export * from "./CLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__